module.exports = "/_next/static/images/6c001e26c4145d89d672e361f6e6a2e7-transfer-icon.svg";